import { useEffect, useMemo } from 'react'
import useApi from 'hooks/useApi'
import { createCsApiUrlFromEndpoint } from 'utils'
import { headerMetaData } from '../PdpHeader/utils'
import NotFound404Page from 'pages/NotFound404Page/NotFound404Page'
import PdpHeader from '../PdpHeader/PdpHeader'
import PdpView from '../PdpView/PdpView'
import type { JobsDetailData, RegionsDetailData, v5 } from '@contracts'
import styles from './ParentPdp.module.scss'

interface ParentPdpProps {
  parentJobId?: string
  parentJobRegionData?: RegionsDetailData
}

export default function ParentPdp({ parentJobId, parentJobRegionData }: ParentPdpProps) {
  const {
    data: parentJobData,
    fetchData: fetchParentJobData,
    isLoading: isParentJobLoading,
    error: parentJobError,
  } = useApi<JobsDetailData>(createCsApiUrlFromEndpoint(`jobs/${parentJobId}`))

  useEffect(() => {
    if (!parentJobId) return
    fetchParentJobData().catch(console.error)
  }, [parentJobId])

  const headerData = useMemo(
    () => headerMetaData(parentJobData as v5.JobsDetailData, parentJobRegionData),
    [parentJobData, parentJobRegionData],
  )

  if ((parentJobError && !parentJobData) || !parentJobId) return <NotFound404Page />

  return (
    <>
      <section className={styles.header}>
        <PdpHeader
          jobData={parentJobData as v5.JobsDetailData}
          headerData={headerData}
          isLoading={isParentJobLoading}
        />
      </section>
      <PdpView
        singleJobData={{ ...(parentJobData as v5.JobsDetailData), status: 'completed' }}
        isInitialising={!parentJobData}
      />
    </>
  )
}
